import React, { useEffect, useState } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom';
import { GetAccess } from '../../../../Components/Utils/roles';
import { useFormik } from 'formik';
import { CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import * as yup from 'yup';
import ContractLayout from './ContractLayout';
import ViewIcon from '../../../../Components/Icons/ViewIcon';
import UseGetDataSearch from '../../../../Components/Hooks/useFetchDataBySearch';
import useFetchMDIndex from '../../../../Components/Hooks/useFetchMDIndex';
import MultiSelect from '../../../../Components/Utils/MultiSelect';
import { NuDate } from '../../../../Components/Utils/Input';
import NuDateFormate  from '../../../../Components/Utils/NuDate';


import UseDropDown from '../../../../Components/Hooks/useDropDown';
import MobileInspectionIndex from '../../../Mobile/ClientManage/Contract/MobileInspectionIndex';



function Inspection() {
     const { contractsViewId } = useParams();
 
            
  const location = useLocation();
   const currentPage= location.state?.currentPage
   const searchQuery= location.state?.searchQuery
   const state = location.state;
 
   const [screenSize, setScreenSize] = useState({
                 width: window.innerWidth,
               });
             
               useEffect(() => {
                 const handleResize = () => {
                   setScreenSize({
                     width: window.innerWidth,
                   });
                 };
             
                 window.addEventListener("resize", handleResize);
             
                 return () => {
                   window.removeEventListener("resize", handleResize);
                 };
               }, []);
            const [filter, setFilter] = useState(
                state?.approvalStatus || state?.category ? true : false
              );
                const [showFilterDialog, setShowFilterDialog] = useState(false);

                   const {value:status} = useFetchMDIndex
                   (`/dropdown/dropdown-details/`,'Status_Schedule',showFilterDialog)
                
                                    const [filterProps, setFilterProps] = useState({
              
                  status:"",
                  dateFrom:"",
                  dateTo:"",
                 
                });


              const [params, setParams] = useState({
             //    page: page,
             //    per_page: pageCount,
             //    search:searchQuery||"",
            
             status:"",
             dateFrom:"",
             dateTo:"",
                 });
            
              const clearFilter = ()=> {
                setParams({...params,status:"", dateFrom:"", dateTo:"",assigneeId:"", })
                formik.values.status=""
                formik.values.dateFrom=""
                formik.values.dateTo=""
              
            
            
                  setFilter(false)
              }
            
              const formik = useFormik({
                enableReinitialize: true,
                initialValues: filterProps,
                validateOnChange: false,
                validateOnBlur: false,
                validationSchema: yup.object({
                  // email: yup.string().required('Email is required!'),
                }),
                onSubmit: async (value, { resetForm }) => {
                  setParams({...params,status:value.status, dateFrom:value.dateFrom, dateTo:value.dateTo, assigneeId:value.assigneeId, })
                  closeFilterDialog();
                  setFilter(true)
                  setFilterProps({
                    status:"",
                    dateFrom:"",
                    dateTo:"",
                    
                  });
                }
              })
              const closeFilterDialog = () => {
                 setShowFilterDialog(false);
               };

                const { data,getData,dataLoading } = UseGetDataSearch( `/schedules/contract/${contractsViewId}`,params);
                 console.log(data,"contractcli");
   return (
     <>
     <ContractLayout
      setFilterOpen={setShowFilterDialog}
           ClearFilter={clearFilter}
           newfilter={true}
           isFilter={filter}
           BackAccess={GetAccess("client_management_module")}
     
     >

      {
        screenSize.width < "768" ?(<>
        <div className=' w-full h-[calc(100vh-175px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden'>
        <MobileInspectionIndex
        data={data}
        // // total={totalCount}
        // pageIndex={page}
        // setPageIndex={setPage}
        // dataCount={pageCount}
        // setDataCount={setPageCount}
        // officeId={officeId}
        getData={getData}
      
        />
        </div>
        </>):(<>
       <div className="overflow-x-auto mt-0.5 rounded-md bg-white h-[calc(100vh-160px)]">
       <table className="min-w-full text-xs text-left">
  <thead>
    <tr className="text-black font-semibold border-b border-gray-300">
      <th className="px-4 py-2 w-[8%]">Ref.</th>
      <th className="px-4 py-2 w-[17.4%]">Client</th>
      <th className="px-4 py-2 w-[17.4%]">Description</th>
      <th className="px-4 py-2 w-[17.4%]">Location</th>
      <th className="px-4 py-2 w-[17.4%]">Inspection Date</th>
      <th className="px-4 py-2 w-[17.4%]">Status</th>
      <th className="px-4 py-2 w-[5%]">Action</th>
    </tr>
  </thead>
  <tbody>
    {data.map((data) => (
      <tr key={data.id} className="hover:bg-gray-50 rounded-md shadow-sm">
        <td className="px-4 py-2 w-[8%] text-left">
          <Link to={`/inspection/schedule/view/${data?.id}`}>
            {data.refNumber || "-"}
          </Link>
        </td>
        <td className="px-4 py-2 w-[17.4%] text-left">
          <Link to={`/inspection/schedule/view/${data?.id}`}>
            {data.clientName || "-"}
          </Link>
        </td>
        <td className="px-4 pt-2 text-left  line-clamp-2 ">
  {data.description || "-"}
</td>



        <td className="px-4 py-2 w-[17.4%] text-left">{data.location || "-"}</td>
        <td className="px-4 py-2 w-[17.4%] text-left">
          {data.date ? (
            <NuDateFormate value={data?.date} format="DD-MMM-YYYY" />
          ) : (
            "N/A"
          )}
        </td>
        <td className="px-4 py-2 w-[17.4%] text-left">{data.status || "-"}</td>
        <td className="px-4 py-2 w-[5%] text-gray-500 text-left">
          <Link
            to={`/inspection/schedule/view/${data?.id}`}
            state={{
              data: data,
              from: `/Contract-management/contracts/inspection/${contractsViewId}`,
            }}
          >
            <ViewIcon color="#048178" />
          </Link>
        </td>
      </tr>
    ))}
  </tbody>
</table>

     </div>

    </>)}

     </ContractLayout>
 
 {showFilterDialog && (
     <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
       <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
         <h2 className="text-xl mb-4">Filter </h2>
         <form onSubmit={formik.handleSubmit}>
           <div className="flex flex-col mb-4">
          <div className="sm:flex justify-between  w-full ">
                                         <NuDate
                                          label="From "
                                          placeholder="dd/mm/yyyy"
                                          formik={formik}
                                          name="dateFrom"
                                          width="w-full"
                                        />
                                         <NuDate
                                          label="To "
                                          placeholder="dd/mm/yyyy"
                                          formik={formik}
                                          name="dateTo"
                                          width="w-full"
                                        />
                                        </div>
                                        {/* <FormikSelectTwo
                                           label="Assignee"
                                           Options={user}
                                           formik={formik}
                                           placeholder="Choose"
                                           name="assigneeId"
                                           width="w-full"
                                            FixPosition={true}
                                            PortalTarget={false}
                                         /> */}
                         <FormikSelectTwo
                        label="Status"
                        Options={status}
                        formik={formik}
                        placeholder="Choose"
                        name="status"
                        isRequired={true}
          
                        width="w-full "
                      />
           </div>
           <div className="flex justify-end gap-2">
             <CancelButton handleClick={closeFilterDialog} />
             <SubmitButton name="Apply" />
           </div>
         </form>
       </div>
     </div>
   )}
   </>
   )
}

export default Inspection